import CryptoJS from "crypto-js";

export const convertToLocalString = (value) => {
  if (!value) {
    return value;
  }

  return value.toLocaleString();
};

const secretKey = "123456";

const base64UrlEncode = (str) =>
  str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

const base64UrlDecode = (str) => {
  str = str.replace(/-/g, '+').replace(/_/g, '/');
  while (str.length % 4) {
    str += '=';
  }
  return str;
};

export const encrypt = (data) => {
  const encrypted = CryptoJS.AES.encrypt(data, secretKey).toString(); // Base64
  return base64UrlEncode(encrypted); // Remove `/`, `+`, `=`
};

export const decrypt = (data) => {
  try {
    const base64 = base64UrlDecode(data); // Convert back to proper Base64
    const decrypted = CryptoJS.AES.decrypt(base64, secretKey);
    const result = decrypted.toString(CryptoJS.enc.Utf8);
    if (!result) throw new Error('Decryption failed');
    return result;
  } catch (e) {
    console.error("Decryption error:", e);
    return null;
  }
};